import { Customer } from '~/customer/model/customer.model'
import { PATHS } from '~/pages/router/paths'
import { getIdByParam } from '~/pages/router/router.helpers'

export const ITEM_SEPARATOR = ':'

export const getAccountByContractId = (accountNumber: string, customer: Customer) => {
  const account = customer.accounts.find((account) => account.accountNumber === accountNumber)
  return account?.id
}

export const getAccountByProductId = (prodId: string, customer: Customer) => {
  const account = customer.accounts.find((account) =>
    account.packages.find((packageItem) =>
      packageItem.subscriptions.find((sub) => sub.identificationNr === prodId),
    ),
  )
  return account?.id
}

// Return all the ids of the elements on the path to the element selected as defined by the routePath
export function getSelectedItemIdsFromRoute(routePath: string, customer: Customer) {
  const productId = getIdByParam('product', routePath, '/')
  const customerId = getIdByParam('customer', routePath, '/')
  const accountNumber = getIdByParam('offers-configurator', routePath, '/')

  const customerPathId = `${PATHS.CUSTOMER}${ITEM_SEPARATOR}${customerId}`
  const offersConfiguratorPathId = `${PATHS.OFFERS_CONFIGURATOR}${ITEM_SEPARATOR}${accountNumber}`

  if (routePath.includes(PATHS.OFFERS_CONFIGURATOR)) {
    return [
      `${customerPathId}/${PATHS.ACCOUNT}${ITEM_SEPARATOR}${getAccountByContractId(
        String(accountNumber),
        customer,
      )}`,
      `${customerPathId}/${PATHS.ACCOUNT}${ITEM_SEPARATOR}${getAccountByContractId(
        String(accountNumber),
        customer,
      )}/${offersConfiguratorPathId}`,
    ]
  }

  if (routePath.includes(PATHS.PRODUCT)) {
    return [
      `${customerPathId}/${PATHS.ACCOUNT}${ITEM_SEPARATOR}${getAccountByProductId(
        String(productId),
        customer,
      )}`,
      `${customerPathId}/${PATHS.ACCOUNT}${ITEM_SEPARATOR}${getAccountByProductId(
        String(productId),
        customer,
      )}/${PATHS.PRODUCT}${ITEM_SEPARATOR}${productId}`,
    ]
  }

  if (routePath.includes(PATHS.ENERGY)) {
    return [`${customerPathId}/${PATHS.ENERGY}`]
  }

  if (routePath.includes(PATHS.CUSTOMER)) {
    return [customerPathId]
  }

  return []
}
